<div class="user-access-complete container-access">
  <div class="header pb-6">
    <div class="d-flex justify-content-center">
      <div class="text-center">
        <h4 class="mb-0">
          <span> {{ formGroupUserDetail?.value?.firstName }} </span>
          <span> {{ formGroupUserDetail?.value?.lastName }} </span>
        </h4>
        <h1 class="modal-title mtm-10 mb-0">
          {{ 'ACCESS_COMPLETED_ACCESS_UPDATED' | translate }}
        </h1>
      </div>
    </div>
  </div>

  <div class="my-3 text-center">
    <img
      src="/assets/svg/ico-completed-check.svg"
      alt="completed access user"
    />
  </div>
  <div class="successfull">
    <ng-container *ngIf="isAccessComplete; else defaultDescription">
      <div>
        {{
          commonService.stringInterPolation(
            ("USER_UPDATE_SUCCESSFULLY" | translate),
            [
              formGroupUserDetail?.value?.firstName,
              formGroupUserDetail?.value?.lastName
            ]
          )
        }}
      </div>
      <br />
      <h4>
        {{ 'REMEMBER_UPDATE_PHYSICAL_CREDENTIAL' | translate }}
      </h4>
    </ng-container>
    <ng-template #defaultDescription>
      {{ 'ACCESS_COMPLETED_CREATED_SHARED_SUCCESSFULLY' | translate }}
    </ng-template>
  </div>

  <div class="row mt-1">
    <div class="col-12 my-1 mb-3">
      <ng-container *ngIf="isAccessComplete; else defaulButton"> </ng-container>
      <ng-template #defaulButton>
        <button
          class="btn primary-btn-black-outline px-3 w-100"
          type="button"
          (click)="addAnotherUser()"
        >
          {{ 'ACCESS_COMPLETED_ADD_ANOTHER_USER' | translate }}
        </button>
      </ng-template>
    </div>

    <ng-container *ngIf="flowType !== CONSTANTS.REMOVE_USER_ACCESS">
      <div class="col-12 my-1">
        <button
          class="btn btn-danger px-3 w-100 btn-submit"
          type="button"
          (click)="closeDialog(true)"
          tabindex="0"
          (keyup.enter)="closeDialog(true)"
          #userAdded
        >
          {{ 'DONE' | translate }}
        </button>
      </div>
    </ng-container>

    <ng-container *ngIf="flowType === CONSTANTS.REMOVE_USER_ACCESS">
      <div class="col-12 my-1">
        <button
          class="btn btn-danger px-3 w-100 btn-submit"
          type="button"
          (click)="navigateToUserAccess()"
          tabindex="0"
          (keyup.enter)="navigateToUserAccess()"
          #userAdded
        >
          {{ 'DONE' | translate }}
        </button>
      </div>
    </ng-container>


  </div>
</div>
